import { Button } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { QuoteStatuses, DialogNames, AnalyticsEventKeys } from '../constants';
import { Dispatch } from '../redux/store';
import currentDate from '../currentDate';

const AcceptQuote = function AcceptQuote(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const onClick = function handleOnClick(): void {
    dispatch.quote.setQuoteStatus(QuoteStatuses.Accepted, currentDate());
    dispatch.dialog.setOpenDialog(DialogNames.SendFeedback);
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.AcceptClicked
    });
  };

  return (
    <Button variant='contained' onClick={onClick}>
      <FormattedMessage id='accept' defaultMessage='Accept' />
    </Button>
  );
};

export default AcceptQuote;
